import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnableFacialRecognitionGuard implements CanActivate {
  constructor(private router: Router) {}

  async canActivate() {
    if (environment.enableFacialRecognition === false) {
      this.router.navigate(['/']);
    }
    return true;
  }
}
